import { z } from "zod"

export const FeedbackImageRulesSchema = z.object({
  maxFileSizeMB: z.number().positive(),
  maxFilesCount: z.number().positive().int(),
  allowedExtensions: z.record(z.string(), z.array(z.string()))
})

export type FeedbackImageRules = z.infer<typeof FeedbackImageRulesSchema>

const S3PresignedPostSchema = z.object({
  url: z.string(),
  fields: z.record(z.string(), z.string())
})

const UploadResponseItemSchema = z.object({
  s3Key: z.string(),
  fileName: z.string(),
  writeUrl: S3PresignedPostSchema
})

export const UploadResponseSchema = z.object({
  uploads: z.array(UploadResponseItemSchema)
})

export type UploadResponseItem = z.infer<typeof UploadResponseItemSchema>
